import { handleAction, combineActions } from 'redux-actions';

import allActions from '../actions/allActions';
import { logoutAction } from '../actions/authentication';
import { clearAllDataAction, loadMockDataAction } from '../actions/data';
import { requestAction } from '../actions/request';
import { isError } from './errors';

const getInitialState = () => ({
  pending: {},
  resolved: {},
  failed: {},
});

export const areRequestsPending = state => (!!Object.keys(state.requests.pending).length);

export const requestReducer = (state, action) => {
  if (action.type === logoutAction.toString() || action.type === clearAllDataAction.toString()) {
    // Clean all data!
    return getInitialState();
  }
  if (action.type === loadMockDataAction.toString()) {
    // Loaded data from local storage
    return {
      ...getInitialState(),
      ...state,
      ...action.payload.requests,
    };
  }
  if (action.type === requestAction.toString()) {
    return {
      ...state,
      pending: {
        ...state.pending,
        [action.meta.id]: action.meta,      
      },
    };
  } else if (action.meta.id) {
    const pending = { ...state.pending };
    delete pending[action.meta.id];
    const resultCollection = isError(action) ? 'failed' : 'resolved';
    return {
      ...state,
      pending,
      [resultCollection]: {
        ...state[resultCollection],
        [action.meta.id]: {
          id: action.meta.id,
          description: action.meta.description,
          time: new Date().toISOString(),
        },
      },
    };
  }
  return state;
};

export default handleAction(combineActions(...allActions), requestReducer, getInitialState());
